'use strict'

const actionTypes = require('./actionTypes')

module.exports.setConnectedComponents = connectedComponents => ({
  type: actionTypes.SET_CONNECTED_COMPONENTS,
  connectedComponents
})
